import { GET_KYC_DETAILS, GET_KYC_DETAILS_SUCCESS, GET_KYC_DETAILS_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  kycData: {},
};

const getKycDetails = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_KYC_DETAILS:
      return { ...state, loading: true };
    case GET_KYC_DETAILS_SUCCESS:
      return {
        ...state,
        kycData: action?.payload,
        loading: false,
      };
    case GET_KYC_DETAILS_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default getKycDetails;
